(function () {
  'use strict';

  function isUsableSecret(secret) {
    secret = String(secret || '').trim();
    return !!(
      secret &&
      secret !== 'anonymous' &&
      secret !== 'secret' &&
      secret !== 'YOUR_API_KEY' &&
      secret !== 'null' &&
      secret !== 'undefined'
    );
  }

  function getStoredSecret() {
    const candidates = [
      window.userData && (window.userData.secret || window.userData.api_key),
      window.userSecret,
      localStorage.getItem('userSecret'),
      sessionStorage.getItem('user_secret'),
    ];
    for (let i = 0; i < candidates.length; i++) {
      if (isUsableSecret(candidates[i])) return String(candidates[i]).trim();
    }
    return '';
  }

  window.netwrckIsUsableSecret = window.netwrckIsUsableSecret || isUsableSecret;
  window.netwrckGetAuthSecret = window.netwrckGetAuthSecret || getStoredSecret;

  window.makeAuthenticatedRequest = function (url, options = {}) {
    const secret = getStoredSecret();

    options.headers = options.headers || {};
    options.headers['Content-Type'] =
      options.headers['Content-Type'] || 'application/json';
    options.headers['Accept'] = 'application/json';

    options.credentials = options.credentials || 'include';

    if (options.body && typeof options.body === 'string') {
      try {
        const bodyData = JSON.parse(options.body);
        if (secret && !bodyData.secret && !bodyData.api_key) {
          bodyData.secret = secret;
          options.body = JSON.stringify(bodyData);
        }
      } catch (e) {
        console.warn('[API-HELPER] Could not parse body as JSON:', e);
      }
    } else if (options.body && typeof options.body === 'object') {
      if (secret && !options.body.secret && !options.body.api_key) {
        options.body.secret = secret;
      }
      options.body = JSON.stringify(options.body);
    }

    if ((!options.method || options.method === 'GET') && secret) {
      const urlObj = new URL(url, window.location.origin);
      if (
        !urlObj.searchParams.has('secret') &&
        !urlObj.searchParams.has('api_key')
      ) {
        urlObj.searchParams.append('secret', secret);
        url = urlObj.toString();
      }
    }

    console.log('[API-HELPER] Making authenticated request to:', url);

    return fetch(url, options);
  };

  const originalFetch = window.fetch;
  window.fetch = function (url, options = {}) {
    let requestPath = '';
    if (typeof url === 'string') {
      try {
        requestPath = new URL(url, window.location.origin).pathname;
      } catch (e) {
        requestPath = url;
      }
    }
    const isApiRequest =
      requestPath.startsWith('/api/') ||
      requestPath === '/fal' ||
      requestPath === '/run' ||
      requestPath === '/wan';

    if (isApiRequest) {
      const secret = getStoredSecret();

      if (secret) {
        options = { ...options };
        options.headers = { ...(options.headers || {}) };

        // Prefer headers for auth to avoid leaking secrets in URLs.
        if (!options.headers['Authorization']) {
          options.headers['Authorization'] = `Bearer ${secret}`;
        }
        if (!options.headers['X-API-Key']) {
          options.headers['X-API-Key'] = secret;
        }

        // If sending a JSON body, inject secret only when explicitly needed by legacy endpoints.
        if (options.body && typeof options.body === 'string') {
          try {
            const bodyData = JSON.parse(options.body);
            if (typeof url === 'string' && url.includes('/api/create-ai')) {
              if ('uid' in bodyData) delete bodyData.uid;
            }
            // Only add secret fields if neither exist and the endpoint is known to expect it in-body.
            const needsBodySecret = typeof url === 'string' && (
              url.includes('/api/create-ai') ||
              url.includes('/api/attach-credits')
            );
            if (needsBodySecret && !bodyData.secret && !bodyData.api_key) {
              bodyData.secret = secret;
              options.body = JSON.stringify(bodyData);
              console.log('[API-HELPER] Added secret to request body');
            }
          } catch (e) {
            // Non-JSON body; skip body mutation
          }
        }
      }
    }

    return originalFetch.call(this, url, options);
  };

  console.log(
    '[API-HELPER] API helper initialized - fetch patched for authenticated requests'
  );
})();
